import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Row, Col, Label, Input, Pagination, Table, PaginationItem, PaginationLink, Button, FormGroup } from "reactstrap"
import { ReactComponent as IconoReversar } from "../../../../assets/icons/HorasExtras/Reversar.svg"
import { ReactComponent as IconoNotificacion } from "../../../../assets/icons/HorasExtras/Notificacion.svg"
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import { ReactComponent as IconoImprimir } from "../../../../assets/icons/HorasExtras/Imprimir.svg"
import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg"
import ModalCargando from 'components/Varios/ModalCargando'
import { authenticationService } from "services/authentication.service";
import { UserData } from 'components/Sidebar/Sidebar_Principal';

import Swal from 'sweetalert2'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
import { GuardarPresupuestoAsignado, GuardarPresupuestoModificado, InformacionUnidadPresupuestoGPE, ParametrosAsignacionPresupuesto, PresupuestoAsignadoUnidad, PresupuestoModificadoUnidad } from './TypesPresupuestoGPEHE'
import { ESTADO_ASIGNADO_PRESUPUESTO, ProyeccionTotal } from 'components/Admin/Horas Extras/Proyeccion Horas Extras/TypesProyecionHorasExtrasAdmin'
import { GetNumberFormatHE } from 'components/Admin/Horas Extras/Proyeccion Horas Extras/TablaUnidadesProyeccionHE'
import { RegimenLaboralHEDTO } from '../PlanificacionHE/TypesPlanificacionHE'
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import "../../../../assets/scss/Horas Extras/AsignacionPresupuesto.scss"
import { AsignarYNotificarPresupuestoUnidad, GuardarModificacionPresupuestoIndividual, GuardarModificacionPresupuestoUnidad, GuardarPresupuestoUnidad, GuardarValorDistribuirMod, ModificarPresupuestoIndividual, ModificarPresupuestoUnidad, ObtenerReporteExcelModificacionPresupuestoGPE } from './FunctionsAsignacionPresupuesto'


import { ReactComponent as EditarSVG } from "../../../../assets/icons/editar.svg";
import { ReactComponent as EditarDisabledSVG } from "../../../../assets/icons/editardisabled.svg";
import { ReactComponent as EnviarSVG } from "../../../../assets/icons/enviar.svg";
import { ReactComponent as CheckSVG } from "../../../../assets/icons/Check.svg";
import { ReactComponent as PDFSVG } from "../../../../assets/icons/HorasExtras/PDF.svg";

import { TipoEncargoUnidad } from 'components/Types/GeneralTypes'
import { ObtenerReporteExcelProyeccionesUnidadesTH, ObtenerReporteProyeccionesUnidadesTH } from 'components/Admin/Horas Extras/Proyeccion Horas Extras/FunctionsProyeccionHorasExtras'
import ModalVistaPreviaDocumento from 'components/Varios/Modals/ModalVistaPreviaDocumento'
import { GetDocumentVistaPrevia } from 'helpers/files'
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos'

// type StateModalReversoUnidades = {
//     showModal: boolean,
//     cargando: boolean,
//     planificacionUnidad: UnidadesProyeccion[],
//     observacion: string
//     content: JSX.Element
// };

type PropsTablaUnidadesGPEPresupuestoHE = {
    selectedUnidades: InformacionUnidadPresupuestoGPE[],
    regimendisponible: RegimenLaboralHEDTO[],
    totalProyeccion: ProyeccionTotal | null
    idPeriodoProyeccion: number,
    tipo: "ASIGNACION" | "MODIFICACION",
    anioInformacionProyeccion: number,
    parametros: ParametrosAsignacionPresupuesto,
    onActualizarTabla: () => Promise<void>,
    defaultRowNumber?: number,
    tipoEncargoUnidad: TipoEncargoUnidad,
    fechaActual: string
    // onGuardarInformacion:(unidades:GuardarPresupuestoAsignado[]) => Promise<void>
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string,
}

export default function TablaUnidadesGPEPresupuestoHE(props: PropsTablaUnidadesGPEPresupuestoHE) {

    // const defaultStateModalReversoUnidades: StateModalReversoUnidades = {
    //     showModal: false,
    //     cargando: false,
    //     planificacionUnidad: [],
    //     observacion: "",
    //     content: <></>
    // };

    // const [unidadSeleccionada, setunidadSeleccionada] = useState<UnidadesProyeccion | undefined>(undefined)
    // const [unidadDeseaReverso, setunidadDeseaReverso] = useState<UnidadesProyeccion | undefined>(undefined)

    // const [motivoReverso, setmotivoReverso] = useState<string>("")
    // const [enviarGPE, setenviarGPE] = useState<boolean>(false)
    // const [loadingAccion, setloadingAccion] = useState<boolean>(false)

    // const [stateModalReversoUnidades, setstateModalReversoUnidades] = useState<StateModalReversoUnidades>(defaultStateModalReversoUnidades)
    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: "",
    }

    const [presupuestoADistribuir, setpresupuestoADistribuir] = useState(0);
    const [valorActualizadoDistribuir, setvalorActualizadoDistribuir] = useState(0);

    const [valorModificar, setvalorModificar] = useState(0);
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [diferenciaADistribuir, setdiferenciaADistribuir] = useState(0)
    const [rowsUnidades, setrowsUnidades] = useState<InformacionUnidadPresupuestoGPE[]>([])
    const [unidadesActualizadas, setunidadesActualizadas] = useState<InformacionUnidadPresupuestoGPE[]>([])

    const [totalProyeccionActualizado, settotalProyeccionActualizado] = useState<ProyeccionTotal | null>(null)
    const [guardando, setguardando] = useState<boolean>(false)
    const [loadingAccion, setloadingAccion] = useState<boolean>(false)
    const [filtrar, setfiltrar] = useState<boolean>(false);
    const [deshabilitarAsignacion, setdeshabilitarAsignacion] = useState<boolean>(false)

    const {
        selectedUnidades,
        anioInformacionProyeccion,
        onActualizarTabla,
        totalProyeccion,
        regimendisponible,
        parametros,
        tipoEncargoUnidad
    } = props;

    const [valoresOriginales, setvaloresOriginales] = useState<InformacionUnidadPresupuestoGPE[]>([...selectedUnidades]);

    useEffect(() => {
        setrowsUnidades(selectedUnidades)
        if (selectedUnidades.length > 0 && selectedUnidades.filter(c => c.valorAsignado && c.estadoProyeccion != "AP").length > 0) {
            setunidadesActualizadas(selectedUnidades.filter(c => c.valorAsignado && c.estadoProyeccion != "AP"))
        }
        
    }, [selectedUnidades])

    useEffect(() => {
        settotalProyeccionActualizado(totalProyeccion)
    }, [totalProyeccion])

    useEffect(() => {
        if (parametros && parametros.valordistribuirinicial) {
            setpresupuestoADistribuir(parametros.valordistribuirinicial)
        }
        else if (parametros && parametros.valordistribuirModificar) {
            setvalorModificar(parametros.valordistribuirModificar);
        }
        else if (valorModificar == 0 && parametros.valordistribuirModificar == null) {
            setvalorModificar(diferenciaDistri);
        }
    }, [parametros, valorModificar])

    useEffect(() => {
        if (parametros.valordistribuirModificar) {
            setvalorModificar(parametros.valordistribuirModificar);
        }
        else if (valorModificar === 0 && parametros.valordistribuirModificar === null) {
            setvalorModificar(diferenciaDistri);
        }

        if (parametros && parametros.fechainicioasignacion && parametros.fechafinasignacion) {
            const fechaInicioAsig = new Date(parametros.fechainicioasignacion)
            const fechaFinAsig = new Date(parametros.fechafinasignacion)
            const fechaActual = new Date(props.fechaActual)
            if (fechaActual.getTime() > fechaFinAsig.getTime() && props.tipo === "ASIGNACION") {
                setdeshabilitarAsignacion(true)
            }
        }
    }, [])

    useEffect(() => {
        if (totalProyeccionActualizado && totalProyeccionActualizado.valorTotalPresupuestoAsignado) {
            setvalorActualizadoDistribuir(totalProyeccionActualizado.valorTotalPresupuestoAsignado)
        }
    }, [totalProyeccionActualizado])

    useEffect(() => {
        setdiferenciaADistribuir((parametros.presupuestoanual ?? 0) - (presupuestoADistribuir ?? 0))
    }, [presupuestoADistribuir])





    // useEffect(() => {
    //     if (rowsUnidades.length > 0 && totalProyeccion) {
    //         const suma = rowsUnidades.reduce((a, i) => {
    //             return a + (i.valorAsignado ?? 0); // Sumar 0 si valorAsignado es null
    //         }, 0)


    //         if (suma >= 0) {
    //             settotalProyeccionActualizado((prev) => {
    //                 if (prev) {
    //                     return { ...prev, valorTotalPresupuestoAsignado: suma }
    //                 }
    //                 else {
    //                     return null
    //                 }
    //             })
    //         }

    //     }
    // }, [rowsUnidades])




    //PAGES
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(props.defaultRowNumber ?? 5);

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    //BUSCADOR

    const [searchTerm, setSearchTerm] = useState('');
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const filteredServidores = rowsUnidades.filter(unid =>
        unid.nombreEstructura.toLowerCase().includes(searchTerm.toLowerCase())
        // actv.estado.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // actv.usuario.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // actv.regimenSiglas.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const filteredServidoresPendientes = rowsUnidades.filter(unid =>
        unid.solicModPresupuesto != null && (unid.estadoProyeccion?.trim() === "GU" || unid.estadoProyeccion?.trim() === "") && unid.nombreEstructura.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const unidadesFiltro = !filtrar ? filteredServidores : filteredServidoresPendientes;

    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);

    let currentRows = unidadesFiltro.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(unidadesFiltro.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleSort = (column: string) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };


    // async function OnClickAccionReverso(informacionUnidad: UnidadesProyeccion | undefined) {
    //     setloadingAccion(true);

    //     if (!informacionUnidad || !informacionUnidad.detalleSolicitudReverso) {
    //         setloadingAccion(false);
    //         await Swal.fire({
    //             title: 'Advertencia',
    //             text: 'Información de unidad no válida.',
    //             icon: 'warning',
    //             confirmButtonText: 'OK'
    //         });
    //         return;
    //     }

    //     const texto = `<div class="custom-modal-content">
    //                         <p>${informacionUnidad.articuloEstructura} <strong>${informacionUnidad.nombreEstructura}</strong> ha solicitado reversar la proyección, por el siguiente motivo:</p>
    //                         <p>${informacionUnidad.detalleSolicitudReverso.motivoReverso}</p>

    //                         <p>¿Desea <b>AUTORIZAR</b> o <b>NEGAR</b> la solicitud de reverso?</p>

    //                     </div>`;

    //     const { idSolicitudReverso } = informacionUnidad.detalleSolicitudReverso;

    //     const result = await Swal.fire({
    //         html: texto,
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: 'Autorizar',
    //         cancelButtonText: 'Negar',
    //         reverseButtons: true,
    //         customClass: {
    //             cancelButton: 'btn-cancelar',
    //             confirmButton: 'btn-aceptar',
    //             popup: 'custom-popup'
    //         },
    //     });


    //     if (result.isConfirmed) {
    //         console.log("confirmo")
    //         await OnClickAccionSolicitudReverso(1, informacionUnidad);
    //     } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
    //         await OnClickAccionSolicitudReverso(2, informacionUnidad);
    //     } else {
    //         setloadingAccion(false);

    //         return;
    //     }

    //     setloadingAccion(false);

    // }

    async function ReportePDF() {
        setloadingAccion(true)
        await ObtenerReporteProyeccionesUnidadesTH(props.idPeriodoProyeccion, "GPE")
        setloadingAccion(false)
    }

    async function ReporteExcel() {
        setloadingAccion(true)
        if (props.tipo === "MODIFICACION") {
            await ObtenerReporteExcelModificacionPresupuestoGPE();
        }
        else {
            await ObtenerReporteExcelProyeccionesUnidadesTH(props.idPeriodoProyeccion, "GPE")
        }
        setloadingAccion(false)
    }


    async function ConfirmacionGuardar(texto: string, valorDistribuir: number, unidadesGuardar: InformacionUnidadPresupuestoGPE[]) {
        const result = await Swal.fire({
            html: texto,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });


        if (result.isConfirmed) {

            await GuardarPresupuestos(valorDistribuir, unidadesGuardar);
        } else {
            return false
        }
    }

    async function ConfirmacionNotificarYAsignar(texto: string, valorDistribuir: number, unidadesGuardar: InformacionUnidadPresupuestoGPE[]) {
        const result = await Swal.fire({
            html: texto,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });


        if (result.isConfirmed) {

            await NotificarYAsignarPresupuestos(valorDistribuir, unidadesGuardar);
        } else {
            return false
        }
    }

    async function GuardarPresupuestos(valorDistribuir: number, unidadesGuardar: InformacionUnidadPresupuestoGPE[]) {
        setguardando(true)

        const presupuestoAsignado: PresupuestoAsignadoUnidad[] = unidadesGuardar.map((v) => {
            return {
                idEstructuraOrganica: v.idEstructuraOrganica,
                porcentaje: v.porcentajeAsignado ?? 0,
                presupuestoAsignado: v.valorAsignado ?? 0
            }
        })

        const infoGuardarPresupuesto: GuardarPresupuestoAsignado = {
            valorDistribuir: valorDistribuir,
            presupuestoAsignado
        }

        const respuesta = await GuardarPresupuestoUnidad(infoGuardarPresupuesto)
        if (respuesta.status === 200) {
            showAlert("Los presupuestos han sido asignados", true)
            setunidadesActualizadas([])
            await props.onActualizarTabla()
        }
        else if (respuesta.status === 401) {
            showAlert("No está autorizado a realizar la acción", false)

        }
        else {
            const messageDefault = "Ha ocurrido un inconveniente al intentar guardar la información";
            showAlert(respuesta.errorMessage ?? messageDefault, false)
        }
        setguardando(false)
    }

    async function NotificarYAsignarPresupuestos(valorDistribuir: number, unidadesGuardar: InformacionUnidadPresupuestoGPE[]) {
        // if(unidadesGuardar.length === 0){
        //     showAlert("No existen cambios en la asignación de presupuesto",false)
        //     return
        // }

        setguardando(true)

        const presupuestoAsignado: PresupuestoAsignadoUnidad[] = unidadesGuardar.map((v) => {
            return {
                idEstructuraOrganica: v.idEstructuraOrganica,
                porcentaje: v.porcentajeAsignado ?? 0,
                presupuestoAsignado: v.valorAsignado ?? 0
            }
        })

        const infoGuardarPresupuesto: GuardarPresupuestoAsignado = {
            valorDistribuir: valorDistribuir,
            presupuestoAsignado
        }

        const respuesta = await AsignarYNotificarPresupuestoUnidad(infoGuardarPresupuesto)
        if (respuesta.status === 200) {
            var mensajeConfirmacion = "Se ha notificado a las unidades"
            if (unidadesGuardar.length === 1) {
                mensajeConfirmacion = "Se ha notificado a la unidad"
            }

            showAlert(mensajeConfirmacion, true)
            setunidadesActualizadas([])
            //await props.onActualizarTabla()
        }
        else if (respuesta.status === 401) {
            showAlert("No está autorizado a realizar la acción", false)

        }
        else {
            const messageDefault = "Ha ocurrido un inconveniente al intentar guardar la información";
            showAlert(respuesta.errorMessage ?? messageDefault, false)
        }
        setguardando(false)
    }

    //Modificacion de presupuesto aumento o decremento
    async function GuardarModificarValor(valorModifica: number, unidad: InformacionUnidadPresupuestoGPE[], isAumento: boolean) {
        setguardando(true)
        var msj = "";

        if (unidad.length < 1) {
            setguardando(false);
            return;
        }
        console.log(unidad)
        unidad.map((r) => {
            if (r.valorModificadoTemp == 0) {
                msj = "No se ha registrado un valor a distribuir"
                return msj;
            }
            else {
                return msj = "";
            }
        })

        if (msj != "") {
            showAlert(msj, false);
            setunidadesActualizadas([]);
            setguardando(false);
            return
        }

        if (isAumento) {
            const suma = unidad.reduce((a, i) => {
                return a + (i.valorModificadoTemp ?? 0); // Sumar 0 si valorAsignado es null
            }, 0)

            if (suma > diferenciaDistri && diferenciaDistri > 0) {
                showAlert("No puede asignarse el valor porque el total de los valores asignados supera el presupuesto a distribuir", false);
                setguardando(false)
                return
            }
            else if (suma > diferenciaDistri || (suma == 0 /*&& suma == diferenciaDistri*/)) {
                showAlert("No puede asignarse el valor porque el total de los valores asignados supera el presupuesto disponible", false);
                setguardando(false)
                return
            }
        }
        const result = await Swal.fire({
            html: "¿Está seguro que desea guardar el presupuesto modificado?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });

        if (result.isConfirmed) {

            const presupuestoModificado: PresupuestoModificadoUnidad[] = unidad.filter((v) => v.valorModificadoTemp !== 0).map((v) => {
                return {
                    IdEstructuraOrganica: v.idEstructuraOrganica,
                    porcentaje: v.porcentajeModificado ?? 0,
                    PresupuestoModificado: v.valorModificadoTemp ?? 0,
                    IsAumento: isAumento,
                }
            })

            const infoPresupuestoMod: GuardarPresupuestoModificado = {
                presupuestoModificado: presupuestoModificado
            }

            //const RespuestaGuardar = await GuardarValorDistribuirMod(valorModifica);
            const guardarModificacion = await GuardarModificacionPresupuestoUnidad(infoPresupuestoMod);
            if (guardarModificacion.status === 200 /*&& RespuestaGuardar.status === 200*/) {
                var mensajeConfirmacion = "Se han guardado las modificaciones"
                showAlert(mensajeConfirmacion, true)
                setunidadesActualizadas([])
                await props.onActualizarTabla()
            }
            else if (guardarModificacion.status === 401 /*&& RespuestaGuardar.status === 401*/) {
                showAlert("No está autorizado a realizar la acción", false)
            }
            else {
                const messageDefault = "Ha ocurrido un inconveniente al intentar guardar la información";
                showAlert(guardarModificacion.errorMessage ?? messageDefault, false)
            }
            setguardando(false)
        }
        else {
            setguardando(false)
            return false
        }

    }

    async function NotificarPresupuesotMod() {
        setguardando(true)

        const result = await Swal.fire({
            html: "¿Está seguro que desea notificar el presupuesto modificado a las unidades correspondientes?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });

        if (result.isConfirmed) {
            const respuestoMod = await ModificarPresupuestoUnidad();
            if (respuestoMod.status === 200) {
                var mensajeConfirmacion = "Se ha notificado a las unidades correspondientes"
                showAlert(mensajeConfirmacion, true)
                setunidadesActualizadas([])
                await props.onActualizarTabla()
            }
            else if (respuestoMod.status === 401) {
                showAlert("No está autorizado a realizar la acción", false)
                setvalorModificar(0)
            }
            else {
                const messageDefault = "Ha ocurrido un inconveniente al intentar guardar la información";
                showAlert(respuestoMod.errorMessage ?? messageDefault, false)
                setvalorModificar(0)
            }
            setguardando(false)
        }
        else {
            setguardando(false)
            return false
        }
        setguardando(false)
    }

    async function GuardarYNotificar(unidad: InformacionUnidadPresupuestoGPE, isAumento: boolean) {
        setguardando(true)

        const result = await Swal.fire({
            html: "¿Está seguro que desea guardar y notificar el presupuesto modificado a la unidad?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });

        if (result.isConfirmed) {

            const presupuestoModificado: PresupuestoModificadoUnidad = {
                IdEstructuraOrganica: unidad.idEstructuraOrganica,
                Porcentaje: unidad.porcentajeModificado ?? 0,
                PresupuestoModificado: unidad.valorModificadoTemp ?? 0,
                IsAumento: isAumento,

            }
            const guardarModificacion = await GuardarModificacionPresupuestoIndividual(presupuestoModificado);
            const respuestoMod = await ModificarPresupuestoIndividual(unidad.idEstructuraOrganica);
            if (respuestoMod.status === 200 && guardarModificacion.status === 200) {
                var mensajeConfirmacion = "Se ha notificado a la unidad correspondiente"
                showAlert(mensajeConfirmacion, true)
                setunidadesActualizadas([])
                await props.onActualizarTabla()
            }
            else if (respuestoMod.status === 401 && guardarModificacion.status === 401) {
                showAlert("No está autorizado a realizar la acción", false)
                setvalorModificar(0)
            }
            else {
                const messageDefault = "Ha ocurrido un inconveniente al intentar guardar la información";
                showAlert(respuestoMod.errorMessage ?? messageDefault, false)
                setvalorModificar(0)
            }
            setguardando(false)
        }
        else {
            setguardando(false)
            return false
        }
        setguardando(false)
    }

    function DistribuirValor(valorDistribuir: number | null, currentRows: InformacionUnidadPresupuestoGPE[]) {
        if (!valorDistribuir || valorDistribuir <= 0) {
            showAlert("El valor de presupuesto a distribuir no es válido", false);
            return
        }

        if (currentRows.length > 0) {
            const copiaRows = currentRows.map((v, i) => {

                if (v.porcentajeAsignado && props.tipo == "ASIGNACION") {
                    const nuevoValor = CalcularValorAsignado(v.porcentajeAsignado, 0, valorDistribuir, "porcentaje");
                    return { ...v, valorAsignado: nuevoValor }
                }
                else if (v.porcentajeModificado && props.tipo == "MODIFICACION") {
                    const nuevoValor = CalcularValorAsignado(v.porcentajeModificado, 0, valorDistribuir, "porcentaje");
                    return { ...v, valorModificadoTemp: nuevoValor }
                }
                else {
                    return { ...v }
                }

            })

            setunidadesActualizadas(copiaRows);
            setrowsUnidades(copiaRows);
        }
        else {
            showAlert("No hay unidades disponibles para distribuir el presupuesto", false);
        }
    }

    function CalcularValorAsignado(porcentaje: number, valorAsignado: number, valorTotal: number, tipoCambiado: "porcentaje" | "valor") {

        if (tipoCambiado === "porcentaje") {
            return (porcentaje / 100) * valorTotal;
        }
        else if (tipoCambiado === "valor") {
            if (valorAsignado <= 0) {
                return 0;
            }
            else if (valorTotal == 0) {
                return 0;
            }
            else {
                return (valorAsignado / valorTotal) * 100;
            }
        }
        else {
            return valorAsignado
        }


    }

    function HabilitarEdicion(infoUnidad: InformacionUnidadPresupuestoGPE, currentRows: InformacionUnidadPresupuestoGPE[]) {
        var copiaUnidades = [...currentRows]
        const indiceUnidadEditar = copiaUnidades.findIndex((v) => v.idEstructuraOrganica === infoUnidad.idEstructuraOrganica);

        if (indiceUnidadEditar > -1) {
            copiaUnidades[indiceUnidadEditar] = { ...infoUnidad, editable: true }
            setrowsUnidades(copiaUnidades)
        }
    }

    function DesHabilitarEdicion(infoUnidad: InformacionUnidadPresupuestoGPE, currentRows: InformacionUnidadPresupuestoGPE[]) {
        var copiaUnidades = [...currentRows]
        const indiceUnidadEditar = copiaUnidades.findIndex((v) => v.idEstructuraOrganica === infoUnidad.idEstructuraOrganica);

        if (indiceUnidadEditar > -1) {

            copiaUnidades[indiceUnidadEditar] = { ...infoUnidad, editable: false }
            setrowsUnidades(copiaUnidades)
        }
    }

    function TdValorPorcentajeAsignado(infoUnidad: InformacionUnidadPresupuestoGPE, currentRows: InformacionUnidadPresupuestoGPE[], idEstructuraUnidad: number, nombre: "porcentaje" | "valor", valor: number | string, presupuestoADistribuir: number, unidadesActualizadas: InformacionUnidadPresupuestoGPE[]) {

        const tieneEstadoNoEditable = (infoUnidad.estadoProyeccion !== null && infoUnidad.estadoProyeccion !== "") && infoUnidad.estadoProyeccion === ESTADO_ASIGNADO_PRESUPUESTO

        var inputDisabled: boolean = tieneEstadoNoEditable && (infoUnidad.editable === undefined || infoUnidad.editable === false)

        if (props.tipo === "MODIFICACION") {
            inputDisabled = infoUnidad.editable === undefined || infoUnidad.editable === false
        }

        const handleChange = (id: number, value: number | null, nombre: "porcentaje" | "valor") => {

            const updatedRows = currentRows.map((row, i) => {
                var porcentaje: number | null = null;
                var valorNuevo: number | null = null;

                if (nombre === "porcentaje") {
                    porcentaje = value !== null ? value : null;
                    valorNuevo = porcentaje !== null ? CalcularValorAsignado(porcentaje, 0, presupuestoADistribuir, nombre) : null;
                }
                else {
                    valorNuevo = value !== null ? value : null;
                    porcentaje = valorNuevo !== null ? CalcularValorAsignado(0, valorNuevo, presupuestoADistribuir, nombre) : null;
                }

                if (row.idEstructuraOrganica === id && props.tipo == "ASIGNACION") {
                    return {
                        ...row,
                        porcentajeAsignado: porcentaje,
                        valorAsignado: valorNuevo
                    }
                }
                else if (row.idEstructuraOrganica === id && props.tipo == "MODIFICACION") {
                    return {
                        ...row,
                        porcentajeModificado: porcentaje,
                        valorModificadoTemp: valorNuevo
                    }
                }
                else {
                    return row
                }

            });

            if (presupuestoADistribuir === 0 && +valor > 0) {
                showAlert("No ha asignado un monto a distribuir", false)
                handleChange(id, null, nombre);
                return;
            }

            const suma = updatedRows.reduce((a, i) => {
                return a + (i.valorAsignado ?? 0); // Sumar 0 si valorAsignado es null
            }, 0)

            const sumaMod = updatedRows.reduce((a, i) => {
                return a + (i.valorModificadoTemp ?? 0); // Sumar 0 si valorAsignado es null
            }, 0)

            if (suma > presupuestoADistribuir && props.tipo == "ASIGNACION") {
                showAlert("No puede asignarse el valor porque el total de los valores asignados supera el presupuesto a distribuir", false)
                handleChange(id, null, nombre);
                return;
            }
            else if (sumaMod > presupuestoADistribuir && presupuestoADistribuir > 0 && props.tipo == "MODIFICACION") {
                showAlert("No puede asignarse el valor porque el total de los valores asignados supera el presupuesto a distribuir", false)
                handleChange(id, null, nombre);
                return;
            }
            else if (sumaMod > diferenciaDistri && props.tipo == "MODIFICACION") {
                showAlert("No puede asignarse el valor porque el total de los valores asignados supera el presupuesto disponible", false)
                handleChange(id, null, nombre);
                return;
            }
            else {
                setrowsUnidades(updatedRows);
                if (suma >= 0) {
                    settotalProyeccionActualizado((prev) => {
                        if (prev) {
                            return { ...prev, valorTotalPresupuestoAsignado: suma }
                        }
                        else {
                            return null
                        }
                    })
                }

                const unidadActualizando = updatedRows.find((v) => v.idEstructuraOrganica == id)

                if (unidadActualizando) {
                    const copiaUnidades = [...unidadesActualizadas];
                    const indiceUnidad = copiaUnidades.findIndex((v) => v.idEstructuraOrganica === unidadActualizando.idEstructuraOrganica)
                    if (indiceUnidad > -1) {
                        copiaUnidades[indiceUnidad] = unidadActualizando;
                        setunidadesActualizadas(copiaUnidades);
                    }
                    else {
                        setunidadesActualizadas([...unidadesActualizadas, unidadActualizando])

                    }
                }

            }

        };

        if (nombre === "porcentaje") {

            return (<td style={{ textAlign: "center" }}>
                <input
                    type="number"
                    className='inputPorcentajeFormatGPE2 '
                    value={valor !== null ? valor : ''}
                    disabled={inputDisabled}
                    onChange={(e) => {
                        const inputValue = e.target.value;

                        // Check if the input is empty
                        if (inputValue === '') {
                            handleChange(idEstructuraUnidad, null, nombre); // Set to null if the input is empty
                        } else {
                            if (+inputValue > 100) {
                                showAlert("No puede ingresar un valor mayor al 100%", false)
                                return;
                            }
                            handleChange(idEstructuraUnidad, +inputValue, nombre); // Otherwise, set the parsed number
                        }
                    }}
                    // onBlur={handleBlur}
                    style={{
                        textAlign: 'center',
                        border: 'none',
                        outline: 'none',
                        borderBottom: '1px solid black',
                        width: '74px',
                        backgroundColor: 'transparent',
                        padding: '5 5 5 5',
                        fontSize: '0.7rem',
                        height: '30px'
                    }}
                />
                {/* {porcentajeAsignado} */}
            </td>
            )
        }
        else if (nombre === "valor") {

            const checkValuePresupuesto = (inputObj: NumberFormatValues) => {
                const { floatValue } = inputObj;

                // Allow empty input
                if (floatValue === undefined) return true;

                // Prevent values greater than presupuestoanual
                if (floatValue > (props.parametros.presupuestoanual ?? 0)) {
                    showAlert("El valor a distribuir no puede ser mayor al presupuesto disponible", false);
                    return false;  // Prevent change
                }
                if (floatValue > diferenciaDistri) {
                    showAlert("El valor a modificar no puede ser mayor al valor a disponible", false);
                    return false;  // Prevent change
                }

                return true; // Allow change if within range
            };

            const changeValor = (inputObj: NumberFormatValues) => {
                const { value } = inputObj;

                const resetValue = () => {
                    handleChange(idEstructuraUnidad, null, nombre); // Restablece el valor a null o a su valor por defecto
                    //value = ''; // Puedes resetear el valor aquí si es necesario
                };

                // Check if the input is empty
                if (value === '') {
                    handleChange(idEstructuraUnidad, null, nombre); // Set to null if the input is empty
                } else {
                    if (+value > presupuestoADistribuir && presupuestoADistribuir > 0) {
                        showAlert("No puede ingresar un valor mayor al presupuesto a distribuir", false)
                        resetValue();
                        return;
                    }
                    else if (+value > diferenciaDistri) {
                        showAlert("No puede ingresar un valor mayor al presupuesto disponible", false)
                        resetValue();
                        return;
                    }
                    handleChange(idEstructuraUnidad, +value, nombre); // Otherwise, set the parsed number
                }
            }

            var negativo = false;
            if (props.tipo == "MODIFICACION") {
                negativo = true;
            }

            return (<td style={{ textAlign: "center" }}>
                <NumberFormat
                    className='form-control'
                    value={valor !== null ? valor : ''}
                    disabled={inputDisabled}
                    thousandSeparator={true}
                    decimalSeparator='.'
                    // fixedDecimalScale={true}
                    fixedDecimalScale={valor !== null && valor !== ''}

                    decimalScale={2}
                    allowNegative={negativo}
                    // allowEmptyFormatting={true}
                    allowEmptyFormatting={false}
                    isAllowed={(values) => checkValuePresupuesto(values)}
                    onValueChange={(values) => changeValor(values)}
                    prefix='$'
                    name='diferenciaDistribuir'
                    style={{
                        textAlign: 'center',
                        border: 'none',
                        outline: 'none',
                        borderBottom: '1px solid black',
                        minWidth: '70px',
                        backgroundColor: 'transparent',
                        padding: '5 5 5 5',
                        fontSize: '0.7rem',
                        height: '30px'
                    }}
                    autoComplete='off'
                />
                {/* <input
                    type="number"
                    value={valor !== null ? valor : ''}
                    onChange={(e) => {
                        const inputValue = e.target.value;

                        // Check if the input is empty
                        if (inputValue === '') {
                            handleChange(idEstructuraUnidad, null); // Set to null if the input is empty
                        } else {
                            if (+inputValue > presupuestoADistribuir) {
                                showAlert("No puede ingresar un valor mayor al presupuesto a distribuir", false)
                                return;
                            }
                            handleChange(idEstructuraUnidad, +inputValue); // Otherwise, set the parsed number
                        }
                    }}
                    style={{
                        textAlign: 'center',
                        border: 'none',
                        outline: 'none',
                        borderBottom: '1px solid black',
                        width: '80px',
                    }}
                /> */}
            </td>
            )
        }
        return <div></div>


    }

    function TdAccionUnidad(unid: InformacionUnidadPresupuestoGPE, currentRows: InformacionUnidadPresupuestoGPE[], valorDistribuir: number) {

        var leyendaCheck = "Presupuesto asignado";
        var leyendaEditar = "Editar presupuesto";
        if (props.tipo == "MODIFICACION") {
            leyendaCheck = "Modificación Asignada";
            leyendaEditar = "Editar Modificación";
        }

        const iconoEditar = deshabilitarAsignacion ? <EditarDisabledSVG id="editarPresupuestoDisabledGPE" title={leyendaEditar} data-toggle="tooltip" data-placement="top" /> : <EditarSVG
            onClick={() => {
                if (deshabilitarAsignacion) { return }
                HabilitarEdicion(unid, currentRows)

            }}
            data-toggle="tooltip"
            data-placement="top"
            title={leyendaEditar}
            id="editarPresupuestoGPE"
        />
        const iconoEnviar = (unid.estadoProyeccion === "AP" && (unid.editable === undefined || unid.editable === false)) ?
                <CheckSVG id="asignadoPresupuestoGPE" title={leyendaCheck} data-toggle="tooltip" data-placement="top"
                />
            :
            < EnviarSVG
                //onClick={() => NotificarYAsignarPresupuestos(valorDistribuir, [unid])}
                onClick={async () => {
                    if (deshabilitarAsignacion) { return }
                    await ConfirmacionNotificarYAsignar("¿Está seguro que desea asignar y notificar el presupuesto?", valorDistribuir, [unid])
                    DesHabilitarEdicion(unid, currentRows);
                }
                }
                data-toggle="tooltip" data-placement="top" title="Guardar y Notificar" id={deshabilitarAsignacion ? "notificarPresupuestoDisabledGPE" :  "notificarPresupuestoGPE"}
            />
        const iconoEnviarMod = ((unid.estadoProyeccion === "" || unid.estadoProyeccion === "AP") && (unid.editable === undefined || unid.editable === false)) ?
            <CheckSVG id="asignadoPresupuestoGPE" title={leyendaCheck} data-toggle="tooltip" data-placement="top"
            />
            :
            < EnviarSVG
                onClick={async () => {
                    await GuardarYNotificar(unid, true)
                    DesHabilitarEdicion(unid, currentRows)
                }
                }
                data-toggle="tooltip" data-placement="top" title="Guardar y Notificar" id="notificarPresupuestoGPE"
            />

        if (props.tipoEncargoUnidad === TipoEncargoUnidad.DELEGADO) {
            return <div className='containerAccionesTHUnidProy'>
                {iconoEditar}
            </div>
        }

        return <div className='containerAccionesTHUnidProy'>
            {iconoEditar}
            {props.tipo === "MODIFICACION" && (
                iconoEnviarMod
            )}
            {props.tipo === "ASIGNACION" && (
                iconoEnviar
            )}
        </div>


        // if (unid.detalleProyeccionRegimen.length === 0) {
        //     return <td />
        // }


        // var classNameNotificacion = "iconAccionTHUnidProyHidden"
        // if (unid.detalleSolicitudReverso !== null) {
        //     classNameNotificacion = "iconAccionTHUnidProy"
        // }



        // if (unid.estadoProyeccion.trim() === ESTADO_ENVIADO_A_TH) {
        //     return (
        //         <td>
        //             <div className='containerAccionesTHUnidProy'>
        //                 <IconoReversar onClick={() => setunidadSeleccionada(unid)} className="iconAccionTHUnidProy" />
        //             </div>
        //         </td>
        //     )
        // }
        // else if (unid.estado.trim() === ESTADO_SOLICITADO_REVERSO_A_TH) {
        //     return (
        //         <td>
        //             <div className='containerAccionesTHUnidProy'>
        //                 <IconoNotificacion onClick={() => OnClickAccionReverso(unid)} className={"iconAccionTHUnidProy"} />
        //             </div>
        //         </td>
        //     )
        // }
        // else {
        //     return <td><span><strong>{unid.estadoString}</strong></span></td>
        // }

    }

    function TBodyTablaProyeccionUnidades(currentRows: InformacionUnidadPresupuestoGPE[], presupuestoADistribuir: number, unidadesActualizadas: InformacionUnidadPresupuestoGPE[]) {

        const tbody = currentRows.map((unid, idunid) => {

            const unidadSeleccionada = valoresOriginales.find((vo) => vo.idEstructuraOrganica === unid.idEstructuraOrganica);

            const presupuestoProyectado = unid.valorProyectado !== null ? GetNumberFormatHE(unid.valorProyectado) : ""
            const presupuestoEjecutado = unid.presupuestoAnteriorEjecutado !== null ? GetNumberFormatHE(unid.presupuestoAnteriorEjecutado) : ""
            const porcentajeAsignado = unid.porcentajeAsignado ?? ""
            const presupuestoAsignado = unid.valorAsignado ?? "" //unid.valorAsignado !== null ? GetNumberFormatHE(unid.valorAsignado) : ""

            //Modificacion
            const presAsignado = unid.valorAsignado !== null ? GetNumberFormatHE(unid.valorAsignado) : GetNumberFormatHE(0)
            const operacionModificada = unid.valorModificadoTemp != null && unid.presupuestoModificado != null ? unid.valorModificadoTemp + unid.presupuestoModificado
                : unid.valorModificadoTemp == null && unid.presupuestoModificado != null ? unid.presupuestoModificado : 0;

            var presModificado = GetNumberFormatHE(operacionModificada);
            var presCodificado = unid.presupuestoCodificado !== null ? GetNumberFormatHE(unid.presupuestoCodificado) : GetNumberFormatHE(0)
            if (unidadSeleccionada) {
                const operacionModificada = unidadSeleccionada.valorModificadoTemp != null && unidadSeleccionada.presupuestoModificado != null ? unidadSeleccionada.valorModificadoTemp + unidadSeleccionada.presupuestoModificado
                    : unidadSeleccionada.valorModificadoTemp == null && unidadSeleccionada.presupuestoModificado != null ? unidadSeleccionada.presupuestoModificado : 0;

                presModificado = GetNumberFormatHE(operacionModificada);

                const operacionCod = (unidadSeleccionada.valorAsignado ?? 0) + operacionModificada;
                presCodificado = GetNumberFormatHE(operacionCod);
            }

            const presDevengado = unid.presupuestoDevengado !== null ? GetNumberFormatHE(unid.presupuestoDevengado) : GetNumberFormatHE(0);
            const presPorDevengar = unid.presupuestoPorDevengar != null ? GetNumberFormatHE(unid.presupuestoPorDevengar) : GetNumberFormatHE(0);

            const porcentajeMod = unid.porcentajeModificado ?? ""
            const valorTempMod = unid.valorModificadoTemp ?? ""

            const totalValorRegimen = unid.detallePresupuestoRegimen.reduce((acc, curr) => {
                return acc + (curr.valor ?? 0);
            }, 0);

            return (
                <React.Fragment key={idunid}>
                    {props.tipo == "ASIGNACION" && (

                        <tr className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE'>
                            <td className="tblProyUnidNombUnid">
                                <div>{unid.nombreEstructura}</div>
                            </td>

                            {
                                unid.detallePresupuestoRegimen.map((v, i) => {
                                    const valorPorcentaje = v.porcentaje ?? ""
                                    const nroHoras = v.nroHoras ?? ""
                                    const valor = v.valor !== null ? GetNumberFormatHE(v.valor) : ""
                                    return (
                                        <React.Fragment key={"detallePresupuestoRegimen " + i}>
                                            <td className='centrado'>{valorPorcentaje}</td>
                                            <td className='centrado'>{nroHoras}</td>
                                            <td>
                                                <div className='containerValorDinero'>
                                                    {valor}
                                                </div>

                                            </td>
                                        </React.Fragment>
                                    )
                                })
                            }

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>

                                    {presupuestoProyectado}
                                </div>

                            </td>

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {presupuestoEjecutado}
                                </div>
                            </td>

                            {TdValorPorcentajeAsignado(unid, currentRows, unid.idEstructuraOrganica, "porcentaje", porcentajeAsignado, presupuestoADistribuir, unidadesActualizadas)}


                            {TdValorPorcentajeAsignado(unid, currentRows, unid.idEstructuraOrganica, "valor", presupuestoAsignado, presupuestoADistribuir, unidadesActualizadas)}

                            <td>
                                {
                                    TdAccionUnidad(unid, currentRows, presupuestoADistribuir)
                                }
                            </td>


                        </tr>
                    )}
                    {props.tipo == "MODIFICACION" && (
                        <tr className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE'>
                            <td className="tblProyUnidNombUnid">
                                <div>{unid.nombreEstructura}</div>
                            </td>

                            {
                                unid.detallePresupuestoRegimen.map((v, i) => {
                                    const valorPorcentaje = v.porcentaje ?? ""
                                    const nroHoras = v.nroHoras ?? ""
                                    const valor = v.valor !== null ? GetNumberFormatHE(v.valor) : ""
                                    return (
                                        <React.Fragment key={"detallePresupuestoRegimen " + i}>
                                            {/* <td className='centrado'>{valorPorcentaje}</td>
                                            <td className='centrado'>{nroHoras}</td> */}
                                            <td>
                                                <div className='containerValorDinero'>
                                                    {valor}
                                                </div>

                                            </td>
                                        </React.Fragment>
                                    )
                                })
                            }

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {GetNumberFormatHE(totalValorRegimen)}
                                </div>
                            </td>

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {presAsignado}
                                </div>
                            </td>

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {presModificado}
                                </div>
                            </td>

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {presCodificado}
                                </div>
                            </td>

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {presDevengado}
                                </div>
                            </td>

                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {presPorDevengar}
                                </div>
                            </td>

                            {/* {TdValorPorcentajeAsignado(unid, currentRows, unid.idEstructuraOrganica, "porcentaje", porcentajeMod, presupuestoADistribuir, unidadesActualizadas)} */}

                            {TdValorPorcentajeAsignado(unid, currentRows, unid.idEstructuraOrganica, "valor", valorTempMod, presupuestoADistribuir, unidadesActualizadas)}

                            <td>
                                {
                                    TdAccionUnidad(unid, currentRows, presupuestoADistribuir)
                                }
                            </td>
                            <td>
                                {unid.solicModPresupuesto && unid.estadoProyeccion === "GU" && (
                                    <div className='containerAccionesTHUnidProy'>
                                        <PDFSVG
                                            className='icono-svg'
                                            onClick={() => onClickVerDoc(unid.solicModPresupuesto)}
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Solicitud Modificación"
                                            id="solicitudModPresupuesto"
                                        />
                                    </div>
                                )}
                                {unid.estadoProyeccion != "GU" && (
                                    <div className='containerAccionesTHUnidProy'>
                                        -
                                    </div>
                                )}
                            </td>
                        </tr>
                    )}
                </React.Fragment>
            )
        })

        return tbody;
    }

    function TFooterTablaProyeccionUnidades(totalProyeccion: ProyeccionTotal | null) {
        if (totalProyeccion !== null) {
            const valorTotalModificado = totalProyeccion.valorTotalPresupuestoModificado != null ? GetNumberFormatHE(totalProyeccion.valorTotalPresupuestoModificado) : GetNumberFormatHE(0);

            // const valorTotalRegimen = totalProyeccion.valorTotalizadoRegimen.filter(v => v.idRegimenLaboral !== 999).reduce((acc, curr) => {
            //     return acc + (curr.valorHoras ?? 0);
            // }, 0);;

            const totalDevengado = currentRows.reduce((acc, curr) => {
                return acc + (curr.presupuestoDevengado ?? 0);
            }, 0);

            const totalPorDevengar = currentRows.reduce((acc, curr) => {
                return acc + (curr.presupuestoPorDevengar ?? 0);
            }, 0);

            // En tu componente, antes del return
            const calcularTotales = () => {
                let totalElemento1 = 0;
                let totalElemento2 = 0;

                currentRows.forEach(row => {
                    row.detallePresupuestoRegimen.forEach(item => {
                        if (item.idRegimenLaboral === 7 && item.valor !== null) {
                            totalElemento1 += item.valor;
                        } else if (item.idRegimenLaboral === 9 && item.valor !== null) {
                            totalElemento2 += item.valor;
                        }
                    });
                });

                return { totalElemento1, totalElemento2 };
            };

            const { totalElemento1, totalElemento2 } = calcularTotales();
            const valorTotalRegimen = totalElemento1 + totalElemento2;

            const totalAsignado = currentRows.reduce((acc, curr) => { return acc + (curr.valorAsignado ?? 0) }, 0);
            const totalModificado = currentRows.reduce((acc, curr) => { return acc + (curr.presupuestoModificado ? curr.presupuestoModificado : curr.valorModificadoTemp ?? 0) }, 0);
            const totalCodificado = totalAsignado + totalModificado; //currentRows.reduce((acc, curr) => { return acc + (curr.presupuestoCodificado ?? 0) }, 0);

            return (
                <tr className="trFooterUnidadProyectado">
                    <td className="tblProyUnidNombUnid">
                        <div>
                            PRESUPUESTO PROYECTADO {anioInformacionProyeccion.toString()}
                        </div>
                    </td>
                    {
                        totalProyeccion.valorTotalizadoRegimen.filter(v => v.idRegimenLaboral !== 999).map((v, i) => {
                            const porcentaje = v.nroHoras ? 100 : ""
                            const nroHoras = v.nroHoras ?? ""
                            const valor = v.valorHoras !== null ? GetNumberFormatHE(v.valorHoras) : "";
                            return (
                                <>
                                    {props.tipo == "ASIGNACION" && (
                                        <React.Fragment key={"presupuestoProyectadoValores " + i}>
                                            <td>{porcentaje}</td>
                                            <td key={v.idRegimenLaboral + "tdVacioNro"}> {nroHoras} </td>
                                            <td key={v.idRegimenLaboral + "tdVacioValor"}>
                                                <div className='containerValorDinero'>
                                                    {valor}
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )}
                                    {/* {props.tipo == "MODIFICACION" && (
                                        <React.Fragment key={"presupuestoProyectadoValores " + i}>
                                            <td>{porcentaje}</td>
                                            <td key={v.idRegimenLaboral + "tdVacioNro"}> {nroHoras} </td>
                                            <td key={v.idRegimenLaboral + "tdVacioValor"}>
                                                <div className='containerValorDinero'>
                                                    {valor}
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )} */}
                                </>
                            )
                        })
                    }
                    {props.tipo === "MODIFICACION" && (
                        <>
                            <td>
                                <div className='containerValorDinero'>
                                    {GetNumberFormatHE(totalElemento1)}
                                </div>
                            </td>
                            <td>
                                <div className='containerValorDinero'>
                                    {GetNumberFormatHE(totalElemento2)}
                                </div>
                            </td>
                        </>
                    )}
                    {props.tipo == "ASIGNACION" && (
                        <td>
                            <div className='containerValorDineroProyectadoGPE'>
                                {totalProyeccion.valorTotalProyeccionActual != null ? GetNumberFormatHE(totalProyeccion.valorTotalProyeccionActual) : ""}

                            </div>

                        </td>
                    )}
                    {props.tipo == "ASIGNACION" && (
                        <td>
                            <div className='containerValorDineroProyectadoGPE'>
                                {totalProyeccion.valorTotalEjecutadoAnioAnterior != null ? GetNumberFormatHE(totalProyeccion.valorTotalEjecutadoAnioAnterior) : ""}

                            </div>
                        </td>
                    )}
                    {props.tipo == "ASIGNACION" && (
                        <>

                            <td>
                                <div>
                                    {/*valor total modificado */}
                                </div>
                            </td>
                        </>
                    )}

                    {props.tipo === "MODIFICACION" && (
                        <td>
                            <div className='containerValorDineroProyectadoGPE'>
                                {GetNumberFormatHE(valorTotalRegimen)}
                            </div>
                        </td>
                    )}

                    <td>
                        <div className='containerValorDineroProyectadoGPE2'>
                            {/* {totalProyeccion.valorTotalPresupuestoAsignado != null ? GetNumberFormatHE(totalProyeccion.valorTotalPresupuestoAsignado) : ""} */}
                            {GetNumberFormatHE(totalAsignado)}
                        </div>
                    </td>

                    {props.tipo == "MODIFICACION" && (
                        <>
                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {/* {
                                        totalProyeccion.valorTotalPresupuestoAsignado !== null &&
                                            totalProyeccion.valorTotalPresupuestoCodificado !== null &&
                                            totalProyeccion.valorTotalPresupuestoCodificado < totalProyeccion.valorTotalPresupuestoAsignado
                                            ? (<>
                                                {valorTotalModificado}
                                            </>)
                                            : valorTotalModificado
                                    } */}
                                    {GetNumberFormatHE(totalModificado)}
                                </div>

                            </td>
                        </>
                    )}
                    {props.tipo == "MODIFICACION" && (
                        <>
                            <td>
                                <div className='containerValorDineroProyectadoGPE'>
                                    {/* {totalProyeccion.valorTotalPresupuestoCodificado != null ? GetNumberFormatHE(totalProyeccion.valorTotalPresupuestoCodificado) : ""} */}
                                    {GetNumberFormatHE(totalCodificado)}
                                </div>
                            </td>
                            <td>
                                <div>
                                    {GetNumberFormatHE(totalDevengado)}
                                </div>
                            </td>
                            <td>
                                <div>
                                    {GetNumberFormatHE(totalPorDevengar)}
                                </div>
                            </td>
                            <td>
                                {valorModificadoTemporal != null ? GetNumberFormatHE(valorModificadoTemporal) : ""}
                            </td>
                            <td>
                                <div></div>
                            </td>
                        </>
                    )}

                    <td />
                </tr>
            )
        }
        else {
            return (
                <tr>
                    <td> PRESUPUESTO PROYECTADO {anioInformacionProyeccion.toString()}</td>
                    {
                        props.regimendisponible.map((v, i) => {
                            return (
                                <React.Fragment key={"presupuestoProyectadoVacio " + i}>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"} />
                                    <td key={v.idRegimenLaboral + "tdVacioValor"} />
                                </React.Fragment>
                            )
                        })
                    }
                    <td colSpan={5} />
                </tr>
            )
        }
    }

    // function AuxiliarGenerarHTMLBodyModalReversarPlanificacion(proyecciones: UnidadesProyeccion[]) {

    //     const contentBody = (
    //         <>

    //             <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
    //                 <thead className="cabecerasDetallehistorialSolic">
    //                     <tr className="" >
    //                         <th> Unidad</th>

    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     {proyecciones.map((proy, ind) => {
    //                         return (
    //                             <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
    //                                 <td className="">
    //                                     <div className="">
    //                                         {proy.nombreEstructura}
    //                                     </div>

    //                                 </td>

    //                             </tr>
    //                         )
    //                     })}
    //                 </tbody>
    //             </Table>

    //         </>

    //     )

    //     return contentBody;
    // }

    // function OnClickAccionReversarUnidades(proyecciones: UnidadesProyeccion[]) {

    //     const estadosReverso: string[] = [ESTADO_ENVIADO_A_TH, ESTADO_SOLICITADO_REVERSO_A_TH];

    //     var planificacionesUnidades = proyecciones.filter(p => p.detalleProyeccionRegimen.length > 0 && estadosReverso.includes(p.estado.trim()))

    //     if (planificacionesUnidades && planificacionesUnidades.length > 0) {
    //         var content = AuxiliarGenerarHTMLBodyModalReversarPlanificacion(planificacionesUnidades)
    //         setstateModalReversoUnidades({
    //             showModal: true,
    //             cargando: false,
    //             planificacionUnidad: planificacionesUnidades,
    //             observacion: "",
    //             content
    //         })
    //     }


    // }


    // const ReversarUnidad = useCallback(
    //     async (unidad: UnidadesProyeccion | undefined, observacion: string) => {

    //         if (unidad === undefined) {
    //             return -1
    //         }

    //         const unidadReverso: ReversarUnidadProyeccionHEDTO = {
    //             unidades: [
    //                 unidad.idEstructuraOrganica
    //             ],
    //             motivo: observacion
    //         }

    //         const respuesta = await ReversarUnidadDesdeTH(unidadReverso)
    //         if (respuesta.status === 200) {
    //             showAlert("La proyección de la unidad " + unidad.nombreEstructura + "ha sido reveresada", true)
    //             await props.onActualizarTabla()
    //             return 1

    //         }
    //         else {
    //             showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
    //             return -1
    //         }
    //     },
    //     [motivoReverso],
    // )

    // async function ReversarProyeccionesUnidades(proyecciones: UnidadesProyeccion[], observacion: string) {
    //     if (proyecciones === undefined || proyecciones.length === 0) {
    //         return -1
    //     }

    //     const unidades: number[] = proyecciones.map((v, i) => { return v.idEstructuraOrganica })

    //     const postReverso: ReversarUnidadProyeccionHEDTO = {
    //         unidades: unidades,
    //         motivo: observacion
    //     }

    //     const respuesta = await ReversarUnidadDesdeTH(postReverso)
    //     if (respuesta.status === 200) {
    //         showAlert("Se ha reversado la proyección de las unidades", true)
    //         await props.onActualizarTabla()
    //         return 1

    //     }
    //     else {
    //         showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
    //         return -1
    //     }

    // }

    // async function EnvioProyeccionesGPE() {

    //     const respuesta = await EnviarProyeccionesUnidadesAGPE(detalleProyeccion.idPeriodoProyeccion);

    //     if (respuesta.status === 200) {
    //         showAlert("Las proyecciones han sido enviadas a Gerencia de Planificación Estratégica", true)
    //         await props.onActualizarTabla()
    //         return 1
    //     }
    //     else {
    //         showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
    //         return -1
    //     }


    // }

    // async function ReportePDF() {
    //     setloadingAccion(true)
    //     await ObtenerReporteProyeccionesUnidadesTH(props.detalleProyeccion.idPeriodoProyeccion)
    //     setloadingAccion(false)
    // }

    // async function ReporteExcel() {
    //     setloadingAccion(true)
    //     await ObtenerReporteExcelProyeccionesUnidadesTH(props.detalleProyeccion.idPeriodoProyeccion)
    //     setloadingAccion(false)
    // }

    // async function OnClickAccionSolicitudReverso(tipoAccion: 1 | 2, informacionUnidad: UnidadesProyeccion | undefined) {
    //     setloadingAccion(true)

    //     if (informacionUnidad && informacionUnidad.detalleSolicitudReverso) {
    //         const infoSolicitud: AtenderSolicitudReverso = {
    //             idSolicitudReverso: informacionUnidad.detalleSolicitudReverso.idSolicitudReverso,
    //             tipoAccion: tipoAccion
    //         }

    //         const respuesta = await PutAtenderSolicituReverso(infoSolicitud);

    //         const textoAutorizacion = tipoAccion === 1 ? "AUTORIZADA" : tipoAccion === 2 ? "NEGADA" : ""

    //         if (respuesta.status === 200) {
    //             showAlert("La solicitud de reverso de proyección ha sido " + textoAutorizacion, true)
    //             await props.onActualizarTabla()

    //         }
    //         else {
    //             showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);

    //         }
    //     }

    //     setloadingAccion(false)
    // }





    // const contenidoModalReversarUnidad = useMemo(
    //     () => {
    //         if (unidadSeleccionada !== undefined) {
    //             return (
    //                 <React.Fragment>
    //                     <Row>
    //                         <Col xl={12}>
    //                             <Row>
    //                                 <Col xl={12}>
    //                                     <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

    //                                 </Col>
    //                                 <Col xl={12}>
    //                                     <Input
    //                                         type="textarea"
    //                                         name="motivoReversoUnidadProy"
    //                                         id="motivoReversoUnidadProy"
    //                                         value={motivoReverso}
    //                                         onChange={(e) => setmotivoReverso(e.target.value)}
    //                                     />
    //                                 </Col>

    //                             </Row>
    //                         </Col>
    //                     </Row>

    //                 </React.Fragment>

    //             )
    //         }
    //         else {
    //             return (
    //                 <div> No se ha seleccionado actividad para editar </div>
    //             )
    //         }
    //     },
    //     [motivoReverso, unidadSeleccionada],
    // )

    // const contenidoModalReversarUnidades = useMemo(

    //     () => {
    //         if (stateModalReversoUnidades && stateModalReversoUnidades.planificacionUnidad.length > 0) {
    //             return (
    //                 <React.Fragment>
    //                     <Row>

    //                         <Col xl={12}>
    //                             <Row>
    //                                 <Col xl={12}>
    //                                     <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

    //                                 </Col>
    //                                 <Col xl={12}>
    //                                     <Input
    //                                         type="textarea"
    //                                         name="motivoReversoUnidadProy"
    //                                         id="motivoReversoUnidadProy"
    //                                         value={motivoReverso}
    //                                         onChange={(e) => setmotivoReverso(e.target.value)}
    //                                     />
    //                                 </Col>

    //                             </Row>
    //                         </Col>
    //                     </Row>


    //                 </React.Fragment>

    //             )
    //         } else {
    //             return (
    //                 <div> No tiene unidades para reversar </div>
    //             )
    //         }

    //     },
    //     [motivoReverso, stateModalReversoUnidades],
    // )

    // const contenidoModalEnviarGPE = () => {
    //     return (
    //         <React.Fragment>
    //             <Row>
    //                 <Col>
    //                     <div className="textModalEnviarAGPE">
    //                         {"¿DESEA ENVIAR A GERENCIA DE PLANIFICACIÓN ESTRATÉGICA LA PROYECCIÓN ANUAL DE HORAS EXTRAS?"}
    //                     </div>
    //                 </Col>
    //             </Row>
    //         </React.Fragment>
    //     )
    // }
    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const usuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, usuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP]
    )

    useEffect(() => {
        if (props.parametros.presupuestoanual && props.parametros.presupuestoanual > 0) {
            setdiferenciaADistribuir(props.parametros.presupuestoanual - presupuestoADistribuir)
        }
    }, [presupuestoADistribuir])

    const onChangeValue = (values, name) => {
        const { formattedValue, value } = values;


        const normalizedValue: number = +value


        if (name === "valorDistribuir") {
            if (normalizedValue > (props.parametros.presupuestoanual ?? 0)) {
                return
            }
            else {
                setpresupuestoADistribuir(normalizedValue)

            }
        }
        else if (name === "valorADistribuir") {
            if (normalizedValue > diferenciaDistri) {
                return
            }
            else {
                setvalorModificar(normalizedValue)
            }
        }
    }

    const valorTotalCodificado = totalProyeccion?.valorTotalPresupuestoCodificado ?? 0;
    const diferenciaDistri = Number(((props.parametros.presupuestoanual ?? 0) - valorTotalCodificado).toFixed(2));
    const SumaModGuardados = rowsUnidades.reduce((a, i) => {
        return a + (i.valorModificadoTemp ?? 0); // Sumar 0 si valorAsignado es null
    }, 0);

    const valorModificadoTemporal = unidadesActualizadas != null ?
        (SumaModGuardados) : 0;

    const diferenciaNoDistribuida = valorModificar - valorModificadoTemporal;

    const checkValueAllowed = (inputObj) => {
        const { floatValue } = inputObj;

        // Allow empty input
        if (floatValue === undefined) return true;

        // Prevent values greater than presupuestoanual
        if (floatValue > (props.parametros.presupuestoanual ?? 0)) {
            showAlert("El valor a distribuir no puede ser mayor al presupuesto disponible", false);
            return false;  // Prevent change
        }
        else if (floatValue > diferenciaDistri && props.tipo == "MODIFICACION") {
            showAlert("El valor a distribuir no puede ser mayor a la diferencia no asignada", false);
            setvalorModificar(0);
            return false;  // Prevent change
        }

        return true; // Allow change if within range
    };

    return (

        <React.Fragment>
            <Row className=" row-no-margin justify-content-start ">
                {props.tipo == "ASIGNACION" && (
                    <>
                        <Col xl={2} className="alignContentend">
                            <FormGroup>
                                <Label>
                                    Valor Presup. anual
                                </Label>
                                <NumberFormat
                                    className='form-control'
                                    value={props.parametros.presupuestoanual}
                                    disabled={true}
                                    thousandSeparator={true}
                                    decimalSeparator='.'
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    allowNegative={false}
                                    allowEmptyFormatting={true}
                                    prefix='$'
                                />
                            </FormGroup>
                        </Col>
                        <Col xl={2} >
                            <FormGroup>
                                <Label>
                                    Valor Presup. distribuir
                                </Label>
                                <NumberFormat
                                    className='form-control'
                                    value={presupuestoADistribuir}
                                    disabled={false}
                                    thousandSeparator={true}
                                    decimalSeparator='.'
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    allowNegative={false}
                                    allowEmptyFormatting={true}
                                    prefix='$'
                                    onValueChange={(values) => onChangeValue(values, "valorDistribuir")}
                                    name='valorDistribuir'
                                    isAllowed={checkValueAllowed}
                                />
                            </FormGroup>
                        </Col>
                        <Col xl={2} className="alignContentend">
                            <FormGroup>
                                <Label>
                                    Diferencia distribuir
                                </Label>
                                <NumberFormat
                                    className='form-control'
                                    value={diferenciaADistribuir}
                                    disabled={true}
                                    thousandSeparator={true}
                                    decimalSeparator='.'
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    allowNegative={false}
                                    allowEmptyFormatting={true}
                                    prefix='$'
                                    name='diferenciaDistribuir'
                                />
                            </FormGroup>
                        </Col>
                    </>
                )}
                {props.tipo == "MODIFICACION" && (
                    <>
                        <div className='border-group'>
                            <Col xl={4} className="alignContentend">
                                <FormGroup>
                                    <Label>
                                        Valor Presup. anual
                                    </Label>
                                    <NumberFormat
                                        className='form-control'
                                        value={props.parametros.presupuestoanual}
                                        disabled={true}
                                        thousandSeparator={true}
                                        decimalSeparator='.'
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        allowNegative={false}
                                        allowEmptyFormatting={true}
                                        prefix='$'
                                    />
                                </FormGroup>
                            </Col>
                            <Col xl={4} className="alignContentend">
                                <FormGroup>
                                    <Label>
                                        Valor Codificado
                                    </Label>
                                    <NumberFormat
                                        className='form-control'
                                        value={valorTotalCodificado}
                                        disabled={true}
                                        thousandSeparator={true}
                                        decimalSeparator='.'
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        allowNegative={false}
                                        allowEmptyFormatting={true}
                                        prefix='$'
                                        name='valorCodificado'
                                    />
                                </FormGroup>
                            </Col>
                            <Col xl={4} className="alignContentend">
                                <FormGroup>
                                    <Label>
                                        Diferencia no Asignada
                                    </Label>
                                    <NumberFormat
                                        className='form-control'
                                        value={diferenciaDistri}
                                        disabled={true}
                                        thousandSeparator={true}
                                        decimalSeparator='.'
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        allowNegative={false}
                                        allowEmptyFormatting={true}
                                        prefix='$'
                                        name='diferenciaDistribuir'
                                    />
                                </FormGroup>
                            </Col>
                        </div>
                        <br />
                        {/* <div className='border-group'>
                            <Col xl={4} className="alignContentend">
                                <FormGroup>
                                    <Label>
                                        Valor a Distribuir
                                    </Label>
                                    <NumberFormat
                                        className='form-control'
                                        value={valorModificar}
                                        disabled={false}
                                        thousandSeparator={true}
                                        decimalSeparator='.'
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        allowNegative={false}
                                        allowEmptyFormatting={true}
                                        prefix='$'
                                        name='valorADistribuir'
                                        onValueChange={(values) => onChangeValue(values, "valorADistribuir")}
                                        isAllowed={checkValueAllowed}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xl={4} className="alignContentend">
                                <FormGroup>
                                    <Label>
                                        Valor Ingresado para Modificar
                                    </Label>
                                    <NumberFormat
                                        className='form-control'
                                        value={valorModificadoTemporal}
                                        disabled={true}
                                        thousandSeparator={true}
                                        decimalSeparator='.'
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        allowNegative={true}
                                        allowEmptyFormatting={true}
                                        prefix='$'
                                        name='valorIngresadoModificar'
                                    />
                                </FormGroup>
                            </Col>
                            <Col xl={4} className="alignContentend">
                                <FormGroup>
                                    <Label>
                                        Diferencia no Distribuida
                                    </Label>
                                    {diferenciaNoDistribuida < 0 && (
                                        <NumberFormat
                                            style={{ color: "#971a04" }}
                                            className='form-control'
                                            value={diferenciaNoDistribuida}
                                            disabled={true}
                                            thousandSeparator={true}
                                            decimalSeparator='.'
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            allowNegative={true}
                                            allowEmptyFormatting={true}
                                            prefix='$'
                                            //onValueChange={(values) => onChangeValue(values, "valorDistribuir")}
                                            name='diferenciaNoDistribuida'
                                        />
                                    )}
                                    {diferenciaNoDistribuida >= 0 && (
                                        <NumberFormat
                                            className='form-control'
                                            value={diferenciaNoDistribuida}
                                            disabled={true}
                                            thousandSeparator={true}
                                            decimalSeparator='.'
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            allowNegative={true}
                                            allowEmptyFormatting={true}
                                            prefix='$'
                                            //onValueChange={(values) => onChangeValue(values, "valorDistribuir")}
                                            name='diferenciaNoDistribuida'
                                        />
                                    )}
                                </FormGroup>
                            </Col>
                        </div> */}
                    </>
                )}

                {props.tipo == "ASIGNACION" && (
                    <Col xl={2} className="alignContentend">
                        <Button disabled={deshabilitarAsignacion} className="btn-backlightblue" onClick={() => DistribuirValor(presupuestoADistribuir, rowsUnidades)}>
                            Distribuir
                        </Button>
                    </Col>
                )}

                {props.tipo == "ASIGNACION" && (
                    <Col xl={4} className="alignContentend">
                        <div className='containerBotonesTablaProyUnid'>

                            <div className='parentBotonesReporteProyGPE2'>

                                <Button
                                    onClick={() => ReportePDF()}
                                    className="btn-white-lightblueborder "
                                    disabled={loadingAccion}
                                >
                                    <div className="containerBotonImprimir">
                                        <div>Imprimir Resumen</div>
                                        <IconoImprimir className="iconBotonImprimir" />
                                    </div>
                                </Button>
                                <Button
                                    disabled={loadingAccion}
                                    onClick={() => ReporteExcel()}
                                    className="btn-Excel "
                                >
                                    <div className="containerBotonImprimir">
                                        <div>Exportar a Excel</div>
                                        <IconoExcel className="iconBotonImprimir" />
                                    </div>
                                </Button>
                            </div>

                            <Button
                                //onClick={() => GuardarPresupuestos(presupuestoADistribuir, unidadesActualizadas)}
                                onClick={() => ConfirmacionGuardar("¿Está seguro que desea guardar los valores de presupuesto?", presupuestoADistribuir, unidadesActualizadas)}
                                className="btn-white-blue  "
                                disabled={deshabilitarAsignacion}
                            >
                                GUARDAR
                            </Button>
                            {
                                props.tipoEncargoUnidad !== TipoEncargoUnidad.DELEGADO &&
                                <Button
                                    //onClick={() => NotificarYAsignarPresupuestos(presupuestoADistribuir, currentRows)}
                                    onClick={() => ConfirmacionNotificarYAsignar("¿Está seguro que desea notificar los presupuestos asignados?", presupuestoADistribuir, unidadesActualizadas)}
                                    className="btn-white-blue "
                                    disabled={deshabilitarAsignacion}
                                >
                                    NOTIFICAR A TODOS
                                </Button>
                            }
                        </div>

                    </Col>
                )}
                {props.tipo === "MODIFICACION" && (
                    <>
                        <Col xl={2}></Col>
                        <Col xl={4}>
                            <div className='containerBotonesTablaProyUnid'>
                                <Button
                                    onClick={() => GuardarModificarValor(valorModificar, unidadesActualizadas, true)}
                                    disabled={false}
                                    className="btn-white-blue  " >
                                    GUARDAR
                                </Button>
                                <Button
                                    onClick={() => NotificarPresupuesotMod()}
                                    disabled={false}
                                    className="btn-white-blue  " >
                                    NOTIFICAR A TODOS
                                </Button>
                            </div>
                            <div className='containerBotonesTablaProyUnid'>
                                <Button
                                    onClick={() => setfiltrar(!filtrar)}
                                    className='btn-white-blue containerBotonesTablaProyUnid' >
                                    Filtrar Pendientes
                                </Button>
                                <Button
                                    disabled={loadingAccion}
                                    onClick={() => ReporteExcel()}
                                    className="btn-Excel "
                                >
                                    <div className="containerBotonImprimir">
                                        <div>Exportar a Excel</div>
                                        <IconoExcel className="iconBotonImprimir" />
                                    </div>
                                </Button>
                            </div>
                        </Col>
                    </>
                )}

            </Row>
            {props.tipo == "ASIGNACION" && (
                <Row className=" row-no-margin parentBotonesReporteProyGPE">
                    <Col xl={8}>
                    </Col>
                    <Col xl={4}>
                        <div className='containerBotonesTablaProyUnid'>
                            <Button
                                onClick={() => ReportePDF()}
                                className="btn-white-lightblueborder "
                                disabled={loadingAccion}
                            >
                                <div className="containerBotonImprimir">
                                    <div>Imprimir Resumen</div>
                                    <IconoImprimir className="iconBotonImprimir" />
                                </div>
                            </Button>
                            <Button
                                disabled={loadingAccion}
                                onClick={() => ReporteExcel()}
                                className="btn-Excel "
                            >
                                <div className="containerBotonImprimir">
                                    <div>Exportar a Excel</div>
                                    <IconoExcel className="iconBotonImprimir" />
                                </div>
                            </Button>
                        </div>
                    </Col>
                </Row>
            )}
            {/* {props.tipo == "MODIFICACION" && (
                <Row className=" row-no-margin parentBotonesReporteProyGPE">
                    <Col xl={2}>
                        <div className='containerBotonesTablaProyUnidStart'>
                            <Button
                                onClick={() => setfiltrar(!filtrar)}
                                className='btn-white-blue containerBotonesTablaProyUnid' >
                                Filtrar Pendientes
                            </Button>
                        </div>
                    </Col>
                    <Col xl={10}>
                    </Col>
                    <Col xl={4}>
                        <div className='containerBotonesTablaProyUnid'>
                            <Button
                                onClick={() => GuardarModificarValor(valorModificar, unidadesActualizadas, true)}
                                disabled={false}
                                className="btn-white-blue  " >
                                GUARDAR
                            </Button>
                            {!(props.tipoEncargoUnidad === TipoEncargoUnidad.DELEGADO) && (
                                <Button
                                    onClick={() => NotificarPresupuesotMod()}
                                    disabled={false}
                                    className="btn-white-blue  " >
                                    NOTIFICAR A TODOS
                                </Button>
                            )}
                        </div>
                    </Col>
                </Row>
            )} */}
            <br />
            <Row className="row-no-margin">
                <Col md="9">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2" // Ajusta el tamaño del select
                            style={{ width: 'auto' }} // Asegura que el select no tome más espacio del necesario
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>
                <Col md="3">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    />
                </Col>
            </Row>
            <Table responsive bordered className="table_planificacion_he">
                <thead className="cabeceras_tabla_planificacion_he">
                    {props.tipo === "ASIGNACION" && (
                        <tr className="borde_cabeceras_he">
                            <th className="thUnidad" rowSpan={2} onClick={() => handleSort('nombreEstructura')}>Unidad</th>
                            {
                                regimendisponible.map((v, i) => {
                                    return (
                                        <th key={"thRegimenSiglas" + i} colSpan={3}> {v.siglasRegimenLaboral}</th>
                                    )
                                })
                            }

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`PRESUPUESTO`} </span>
                                <br />
                                <span>{`PROYECTADO ${anioInformacionProyeccion}`}</span>

                            </th>

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`PRESUPUESTO`}</span>
                                <br />
                                <span>{`EJECUTADO ${anioInformacionProyeccion - 1}`} </span>
                            </th>

                            <th className="thPresupuestosProyUnGPE" colSpan={2}  > {`PRESUPUESTO ASIGNADO`}</th>

                            <th rowSpan={2} > {`Acciones`}</th>

                        </tr>
                    )}
                    {props.tipo === "MODIFICACION" && (
                        <tr className="borde_cabeceras_he">
                            <th className="thUnidad" rowSpan={2} onClick={() => handleSort('nombreEstructura')}>Unidad</th>
                            {
                                regimendisponible.map((v, i) => {
                                    return (
                                        <th key={"thRegimenSiglas" + i} colSpan={1}> {v.siglasRegimenLaboral}</th>
                                    )
                                })
                            }

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`TOTAL SOLICITADO`} </span>
                                <br />
                                <span>{`A INCREMENTAR`}</span>

                            </th>

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`PRESUPUESTO`} </span>
                                <br />
                                <span>{`ASIGNADO`}</span>

                            </th>

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`PRESUPUESTO`}</span>
                                <br />
                                <span>{`MODIFICADO`} </span>
                            </th>

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`PRESUPUESTO`}</span>
                                <br />
                                <span>{`CODIFICADO`} </span>
                            </th>

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`PRESUPUESTO`}</span>
                                <br />
                                <span>{`DEVENGADO`} </span>
                            </th>

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`PRESUPUESTO`}</span>
                                <br />
                                <span>{`POR DEVENGAR`} </span>
                            </th>

                            <th className="thPresupuestosProyUnGPE" rowSpan={2} >
                                <span>{`VALOR A`}</span>
                                <br />
                                <span>{`MODIFICAR`} </span>
                            </th>

                            <th rowSpan={2} > {`Acciones`}</th>

                            <th rowSpan={2}>
                                <span> {`SOLICITUD`} </span>
                                <br />
                                <span> {`UNIDAD`} </span>
                            </th>

                        </tr>
                    )}

                    {props.tipo === "ASIGNACION" && (
                        <tr>
                            {
                                regimendisponible.map((v, i) => {
                                    return (
                                        <React.Fragment key={"fieldRD " + i}>
                                            <th>
                                                %
                                            </th>
                                            <th>
                                                Núm. Horas
                                            </th>
                                            <th className="thValorRegimenProyUn">
                                                Valor
                                            </th>
                                        </React.Fragment>

                                    )
                                })
                            }
                            <th className="">
                                %
                            </th>
                            <th className='thPresupuestosProyUn'>
                                Valor
                            </th>
                        </tr>
                    )}
                    {props.tipo === "MODIFICACION" && (
                        <tr>
                            {
                                regimendisponible.map((v, i) => {
                                    return (
                                        <React.Fragment key={"fieldRD " + i}>
                                            {/* <th>
                                                %
                                            </th>
                                            <th>
                                                Núm. Horas
                                            </th> */}
                                            <th className="thValorRegimenProyUn">
                                                Valor solicitado
                                            </th>
                                        </React.Fragment>

                                    )
                                })
                            }
                            {/* <th className="">
                                %
                            </th>
                            <th className='thPresupuestosProyUn'>
                                Valor
                            </th> */}
                        </tr>
                    )}
                </thead>
                <tbody>
                    {props.tipo == "ASIGNACION" && (
                        TBodyTablaProyeccionUnidades(currentRows, presupuestoADistribuir, unidadesActualizadas)
                    )}
                    {props.tipo == "MODIFICACION" && (
                        TBodyTablaProyeccionUnidades(currentRows, valorModificar, unidadesActualizadas)
                    )}
                </tbody>
                <tfoot id="footTablaProyeccionUnidadesTH">
                    {TFooterTablaProyeccionUnidades(totalProyeccionActualizado)}
                </tfoot>

            </Table>
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>

            <ModalCargando
                show={guardando}
                onClose={() => setguardando(false)}
                size='md'
            />

            <ModalCargando
                show={loadingAccion}
                onClose={() => setloadingAccion(false)}
                size='md'
            />

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento solicitud de modificacion del presupuesto unidad'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

        </React.Fragment>

    )
}
